import i18n from 'i18n/config';

export default [
  { value: 0.033, text: i18n.t('Daily') },
  { value: 1, text: i18n.t('Monthly') },
  { value: 3, text: i18n.t('Quarterly') },
  { value: 6, text: i18n.t('Biannual') },
  { value: 12, text: i18n.t('Yearly') },
];
